export function cleanCnpj(value) {
  return String(value || '')
    .replace(/[^0-9a-z]/gi, '')
    .toUpperCase()
    .slice(0, 14);
}

export function formatCnpj(value) {
  return cleanCnpj(value)
    .replace(/^(.{2})(.{1,3})/, '$1.$2')
    .replace(/^(.{2})\.(.{3})(.{1,3})/, '$1.$2.$3')
    .replace(/^(.{2})\.(.{3})\.(.{3})(.{1,4})/, '$1.$2.$3/$4')
    .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(.{1,2})/, '$1.$2.$3/$4-$5');
}

export function moveCnpjCursor(input, cleanPosition) {
  const formattedValue = input.value;
  let validCharacters = 0;

  if (cleanPosition === 0) {
    input.setSelectionRange(0, 0);
    return;
  }

  for (let index = 0; index < formattedValue.length; index += 1) {
    if (/[0-9a-z]/i.test(formattedValue[index])) validCharacters += 1;
    if (validCharacters >= cleanPosition) {
      input.setSelectionRange(index + 1, index + 1);
      return;
    }
  }

  input.setSelectionRange(formattedValue.length, formattedValue.length);
}

export function formatCnpjInput(event) {
  const input = event.target;
  const cleanBeforeCursor = cleanCnpj(input.value.slice(0, input.selectionStart)).length;

  input.value = formatCnpj(input.value);
  moveCnpjCursor(input, cleanBeforeCursor);
}
